import { all, fork } from "redux-saga/effects";
import authSaga from "./auth/saga";
import usersMasterSaga from "./users/saga";
import homesMasterSaga from "./home/saga";
import contactMasterSaga from "./contactus/saga";
import restaurantMasterSaga from "./restaurant/saga";
import casestudyMasterSaga from "./casestudy/saga";

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(usersMasterSaga),
    fork(homesMasterSaga),
    fork(contactMasterSaga),
    fork(restaurantMasterSaga),
    fork(casestudyMasterSaga),
  ]);
}
